// src/redux/companyAdhoc/companyAdhocSelectors.js

// ✅ Create Company Adhoc
export const selectCreateCompanyAdhocData = (state) =>
  state?.companyAdhoc?.createCompanyAdhoc?.data;
export const selectCreateCompanyAdhocLoading = (state) =>
  state?.companyAdhoc?.createCompanyAdhoc?.loading;
export const selectCreateCompanyAdhocError = (state) =>
  state?.companyAdhoc?.createCompanyAdhoc?.error;

// ✅ Company Adhoc Listing
export const selectCompanyAdhocList = (state) =>
  state?.companyAdhoc?.getCompanyAdhocListing?.data || [];
export const selectCompanyAdhocListLoading = (state) =>
  state?.companyAdhoc?.getCompanyAdhocListing?.loading;
export const selectCompanyAdhocListError = (state) =>
  state?.companyAdhoc?.getCompanyAdhocListing?.error;
export const selectCompanyAdhocListTotal = (state) =>
  state?.companyAdhoc?.getCompanyAdhocListing?.total || 0;

// ✅ Company Adhoc Tools Candidates Count
export const selectCompanyAdhocToolsCandidatesCountData = (state) =>
  state?.companyAdhoc?.getCompanyAdhocToolsCandidatesCount?.data;
export const selectCompanyAdhocToolsCandidatesCountLoading = (state) =>
  state?.companyAdhoc?.getCompanyAdhocToolsCandidatesCount?.loading;
export const selectCompanyAdhocToolsCandidatesCountError = (state) =>
  state?.companyAdhoc?.getCompanyAdhocToolsCandidatesCount?.error;

// ✅ Company Adhoc Tools
export const selectCompanyAdhocTools = (state) =>
  state?.companyAdhoc?.getCompanyAdhocTools?.data;
export const selectCompanyAdhocToolsLoading = (state) =>
  state?.companyAdhoc?.getCompanyAdhocTools?.loading;
export const selectCompanyAdhocToolsError = (state) =>
  state?.companyAdhoc?.getCompanyAdhocTools?.error;

// ✅ Company Adhoc Detail
export const selectCompanyAdhocDetail = (state) =>
  state?.companyAdhoc?.getCompanyAdhocDetail?.data;
export const selectCompanyAdhocDetailLoading = (state) =>
  state?.companyAdhoc?.getCompanyAdhocDetail?.loading;
export const selectCompanyAdhocDetailError = (state) =>
  state?.companyAdhoc?.getCompanyAdhocDetail?.error;

// ✅ Edit Company Adhoc
export const selectEditCompanyAdhocData = (state) =>
  state?.companyAdhoc?.editCompanyAdhoc?.data;
export const selectEditCompanyAdhocLoading = (state) =>
  state?.companyAdhoc?.editCompanyAdhoc?.loading;
export const selectEditCompanyAdhocError = (state) =>
  state?.companyAdhoc?.editCompanyAdhoc?.error;

// ✅ Combined
export const selectCompanyAdhocState = (state) => state?.companyAdhoc;